import config from '../config'
import render_fragments from './render_fragments'

import $ from 'jquery'

var options = {
	'enable' : true,
	'dom' : {
		'delegator' : 'body',
		'form' : '.ajax-filters',
		'parent' : '.ajax-search',
		'results' : '.ajax-results',
		'pagination_item' : '.ajax-pagination a'
	},
	'spinner' : '<div class="uk-overlay uk-overlay-default uk-position-cover uk-margin-remove uk-width-1-1"><div class="uk-position-center"><div uk-spinner></div></div></div>'
}

if(options.enable){
	$(options.dom.delegator).on('submit', options.dom.form, bind_filter_form)
	$(options.dom.delegator).on('click', options.dom.pagination_item, change_filter_form_page)
}

function show_loader($wrapper, $loader){
	$wrapper.append($loader)
}

function remove_loader($loader){
	$loader.fadeOut(500, function(){
		$loader.remove()
	});
}

function bind_filter_form(event){
	submit_filter_form($(event.target), 1);
	return false;
}

function submit_filter_form($form, page){
	var $results = $form.closest(options.dom.parent).find(options.dom.results);

	var $loader = $(options.spinner);
	show_loader($results, $loader);

	var search_id = $form.find('[name=search_id]').val();

	var form_data = $form.serialize() + '&'+search_id+'_page=' + page;

	$.get( window.location.href, form_data + '&result_fragment=true',  function( data ) {
		render_fragments(data, true)
		window.history.pushState('', '', '?' + form_data);
		remove_loader($loader);
	});
	
	return false;
}

function change_filter_form_page(event){
	event.preventDefault();
	var $link = $(event.currentTarget);
	var $form = $link.closest(options.dom.parent).find(options.dom.form);
	var page = $link.data('page')
	submit_filter_form($form, page)
}



// WEBPACK FOOTER //
// ./resources/assets/js/src/filter_lists.js